module.exports = {
    none: "none",
    organizer: "organizer",
    tentatively_accepted: "tentatively_accepted",
    accepted: "accepted",
    declined: "declined",
    not_responded: "not_responded"
};
